import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import usePrevious from 'src/common/hooks/usePrevious';
import { selectIsAuthenticated } from 'src/common/selectors/auth';
import { useStores } from 'src/common/stores';

export function useAuthEffects() {
  const { favoritesStore } = useStores();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const prevIsAuthenticated = usePrevious(isAuthenticated);
  const favoriteOnAuthCallback = favoritesStore.favoriteOnAuthCallback();

  useEffect(() => {
    if (isAuthenticated && !prevIsAuthenticated) {
      favoriteOnAuthCallback?.();
    }
  }, [isAuthenticated, prevIsAuthenticated, favoriteOnAuthCallback]);
}
